// extracted by css-extract-rspack-plugin
export default {"CardBody":"CardBody-xBzrQL","cardBody":"CardBody-xBzrQL","CardText":"CardText-F5EDkk","cardText":"CardText-F5EDkk"};